import "./VendorProcurementAdvisory.module.css";
import Header from "@/reusable_sections/Header";
import OptimizeYourSupplyChainWithExpertAdvisory from "./sections/OptimizeYourSupplyChainWithExpertAdvisory";
import UnlockTheBenefitsOfStrategicProcurement from "./sections/UnlockTheBenefitsOfStrategicProcurement";
import Footer from "@/reusable_sections/Footer";
export default function VendorProcurementAdvisoryPage() {
  return <div>
      <Header />
      <OptimizeYourSupplyChainWithExpertAdvisory />
      <UnlockTheBenefitsOfStrategicProcurement />
      <Footer />
    </div>;
}